import { ETrackingSiteType } from '../types';

export const getTrackingSiteType = (isMicrofrontend: boolean, isMobile: boolean): ETrackingSiteType => {
  if (!isMicrofrontend) {
    return ETrackingSiteType.App;
  }

  return isMobile ? ETrackingSiteType.Mobile : ETrackingSiteType.Desktop;
};
